import { useTranslation } from 'react-i18next';

interface Props {
  current: 1 | 2 | 3;
}

const dotBaseStyle: React.CSSProperties = {
  width: 28,
  height: 28,
  borderRadius: 'var(--radius-full)',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 'var(--font-size-sm)',
  fontWeight: 700,
  border: '2px solid var(--color-surface-border)',
  background: 'var(--color-surface-elevated)',
  color: 'var(--color-text-muted)',
  flexShrink: 0,
};

const barStyle: React.CSSProperties = {
  flex: 1,
  height: 2,
  minWidth: 24,
  background: 'var(--color-surface-border)',
};

/** ③ 위저드 진행 단계 표시 — biz-designs/project-scaffold.html §6.2 .stepper 그대로. */
export function ScaffoldStepper({ current }: Props) {
  const { t } = useTranslation();
  const labels = [t('projectScaffold.step.meta'), t('projectScaffold.step.modules'), t('projectScaffold.step.preview')];

  return (
    <div className="scaffold-stepper" role="list" aria-label={t('projectScaffold.title')} style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-2)', marginBottom: 'var(--spacing-6)', flexWrap: 'wrap' }}>
      {labels.map((label, idx) => {
        const stepNum = (idx + 1) as 1 | 2 | 3;
        const done = stepNum < current;
        const active = stepNum === current;
        return (
          <div key={label} style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-2)', flex: idx < 2 ? '0 0 auto' : undefined }}>
            <div role="listitem" style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-2)' }}>
              <span
                style={{
                  ...dotBaseStyle,
                  ...(active
                    ? { background: 'var(--color-brand-primary)', borderColor: 'var(--color-brand-primary)', color: 'var(--color-text-inverse)' }
                    : done
                    ? { background: 'var(--color-success)', borderColor: 'var(--color-success)', color: 'var(--color-text-inverse)' }
                    : {}),
                }}
              >
                {done ? '✓' : stepNum}
              </span>
              <span style={{ fontSize: 'var(--font-size-sm)', color: active ? 'var(--color-text-primary)' : 'var(--color-text-secondary)', fontWeight: active ? 700 : 400 }}>
                {label}
              </span>
            </div>
            {idx < 2 && <span style={{ ...barStyle, ...(done ? { background: 'var(--color-success)' } : {}) }} />}
          </div>
        );
      })}
    </div>
  );
}
